export default __webpack_public_path__ + "781a3275516028c3ff132091a89227e0dcb78d974e61921c4425664ff7012727.png";